import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {Tabs, Tab} from 'react-bootstrap';
import './aboutUs.css';


const AboutUs = () => {
  return (
    <>
     <div className='container my-5'>
        <div className=' capacity-card'>
            <div className=' capacity-card-body'>
                <h1 className=' text-center'>About Us</h1>
                <div className='text-center fw-bold'>Welcome to GNA Energy – Your Trusted OTC Electricity Platform</div>
                <p className='text-center'>At GNA Energy, we are passionate about revolutionizing the Indian Power Market. We have a simple yet powerful vision: to create a transparent, efficient, and customer-centric Over-The-Counter platform for electricity.</p>
                
                <Row>
                    <Col md={12} id='about_us'>
                       <Tabs variant='pills' className='mt-2'
                        defaultActiveKey={'Who We Are'}
                        >
                            <Tab eventKey={'Who We Are'} title="Who We Are">
                                <p>We are a regulated entity and the Central Electricity Regulatory Commission (CERC) has granted us registration to establish and operate an OTC Platform for the Indian Power Market.</p>
                                <p>Our team of dedicated professionals comes with years of experience in the energy industry. Our diverse energy, technology, data, and regulatory backgrounds have come together to build a platform that empowers generators, discoms, utilities, and commercial and industrial consumers to take control of their electricity needs.</p>
                                
                            </Tab>
                            <Tab eventKey={'Our Mission'} title="Our Mission">
                            <p>Our mission is to make electricity accessible, understandable, and reliable for everyone. We believe that electricity is not just a utility; it's a vital resource that powers our lives, businesses, and economies. Through our OTC platform, we aim to:</p>
                            <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Empower Customers</strong>: We put the power in your hands, allowing you to choose your electricity suppliers with ease.</div>
                            <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Promote Transparency</strong>: We are committed to transparency so you can make informed decisions.</div>
                            <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Drive Innovation</strong>: We constantly innovate to bring you the latest technology and features that simplify the process and optimize the performance of every market participant.</div>
                            
                            </Tab>
                            <Tab eventKey={'Why Choose Us?'} title="Why Choose Us?">
                            <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Expertise</strong>: Our team consists of experts in the energy industry who understand the complexities of electricity markets.</div>
                            <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Transparency</strong>: We believe in complete transparency in every interaction, ensuring you always know what you're getting.</div>
                            <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Customer-Centric</strong>: Your satisfaction is our priority. We are here to support you every step of the way.</div>
                            <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Innovation</strong>: We are always at the forefront of technological advancements in the energy sector, providing you with the best tools and resources.</div>
                            <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Made in India</strong>: Our platform has been developed to cater to the specific structure and requirements of the Indian Power Market.</div>
                                
                            </Tab>

                            <Tab eventKey={'Our Commitment to Sustainability'} title="Our Commitment to Sustainability">
                            <p>We are committed to a sustainable future. We support the transition to cleaner, more environmentally friendly electricity sources. By choosing GNA Energy, you are contributing to a greener world.</p>
                            <p>We invite you to join us on this journey to reshape the electricity landscape in India. </p>
                            <p>If you have any questions or would like to learn more, please don't hesitate to reach out to our team. We look forward to serving you!</p>
                            
                                
                            </Tab>
                        </Tabs>
                       
                    </Col>
                </Row>

                <Row className='mt-5'>
                    <div className='co-md-12'>
                    <h2 className=' text-center'>Our Services</h2>
                    </div>

                </Row>


                <Row className='my-3 service_wrap'>
                    <Col md={3}>
                    <div className='shadow-sm  text-center'>
                    <img className='img-fluid' src='images/gna-service-1.png' alt='' />
                    <div className='team-members'>
                       <h4 className='team-members-name'>OTC Platform</h4>
                        <div>Electricity Demand & Supply Requirements</div>
                    </div>
                    </div>
                    </Col>

                    <Col md={3}>
                    <div className='shadow-sm  text-center'>
                    <img className='img-fluid' src='images/gna-service-2.png' alt='' />
                    <div className='team-members'>
                       <h4 className='team-members-name'>Bulletin Board</h4>
                        <div>Power Market Products & Services</div>
                    </div>
                    </div>
                    </Col>

                    <Col md={3}>
                    <div className='shadow-sm  text-center'>
                    <img className='img-fluid' src='images/gna-service-3.png' alt='' />
                    <div className='team-members'>
                       <h4 className='team-members-name'>Energy Management</h4>
                        <div>Cost Optimisation & Monitoring</div>
                    </div>
                    </div>
                    </Col>

                    <Col md={3}>
                    <div className='shadow-sm  text-center'>
                    <img className='img-fluid' src='images/gna-service-4.png' alt='' />
                    <div className='team-members'>
                       <h4 className='team-members-name'>Data & Analytics</h4>
                        <div>Actionable Insights</div>
                    </div>
                    </div>
                    </Col>
                    
                </Row>

                <Row className='mt-4'>
                    <Col md={12}>
                        <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>OTC Platform</strong>: List your electricity demand and supply requirements. Find available consumers and suppliers of electricity. Communicate transparently.</div>
                        <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Bulletin Board</strong>: Browse through a diverse list of products and services for the power market and find the right service provider. </div>
                        <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Energy Management</strong>: Optimise electricity consumption, reduce costs, and minimize environmental impact.</div>
                        <div><i className='fa fa-dot-circle-o icon-dot-circle'></i><strong>Data and Analytics: Access pan-India dataset and predictive analytics for the Indian Power Market. Get actionable insights and make informed decisions.</strong></div>
                    </Col>
                </Row>
            </div>
        </div>
     </div>
    </>
  );
}

export default AboutUs;
